import * as React from "react";

function DocumentIcon(props) {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.5 12.2009L12.5 18.1969L1.502 18.2009C1.23749 18.202 0.983369 18.098 0.795486 17.9118C0.607603 17.7256 0.501323 17.4724 0.5 17.2079V1.19393C0.5 0.645928 0.945 0.200928 1.493 0.200928H17.507C18.055 0.200928 18.5 0.656928 18.5 1.20293V12.2009ZM16.5 2.20093H2.5V16.2009H10.5V11.2009C10.5 10.956 10.59 10.7196 10.7527 10.5366C10.9155 10.3535 11.1397 10.2366 11.383 10.2079L11.5 10.2009L16.5 10.1999V2.20093ZM15.671 12.1999L12.5 12.2009V15.3699L15.671 12.1999Z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoDocumentIcon = React.memo(DocumentIcon);
export default MemoDocumentIcon;
